const constant = {
	city : [
		'北京','天津','上海','重庆','安徽','福建','甘肃','广东','广西','贵州','海南','河北','河南','黑龙江','湖北',
		'湖南','吉林','江苏','江西','辽宁','内蒙古','宁夏','青海','山东','山西','陕西','四川','西藏','新疆','云南',
		'浙江'
	]
};

export default constant;



// WEBPACK FOOTER //
// ./src/constant/index.js